export default __webpack_public_path__ + "static/10-6527ea4af55be5874efa46e6d5109bc3.png";